export const getFormattedDate = (): string => {
    const date = new Date();
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();

    // Function to get the ordinal suffix for the day
    const getOrdinalSuffix = (day: number): string => {
        if (day > 3 && day < 21) return 'th'; // Special case for 11th, 12th, 13th, etc.
        switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    }
    const ordinalSuffix = getOrdinalSuffix(day);
    return `${day}${ordinalSuffix} of ${month} ${year}`;
}
